export const API_SERVER_URL = "https://apiserver.giftadeed.com"
// export const API_SERVER_URL = "http://161.97.77.64:4500";
// export const API_SERVER_URL = "http://ktspldemo.co.in:4500";
// export const API_SERVER_URL = "http://161.97.107.171:4000";
// export const API_SERVER_URL = "http://localhost:7000";
// 
// export const IMAGE_URL =  "http://161.97.77.64:4500"
export const IMAGE_URL = "https://apiserver.giftadeed.com"